// extracted by mini-css-extract-plugin
module.exports = {"cube":"lastUpdate_cube__1pJTa","lastUpdateName":"lastUpdate_lastUpdateName__1VZqJ","lastUpdateCubeLogo":"lastUpdate_lastUpdateCubeLogo__3sS_3"};